// Geometry of the capsule behind the current tab (hooks/useTabBarDrag), ported from OdeParfum.

/** How far the capsule reaches past its tab on each side (5.3px from the pill's edge at the first and last tab). */
export const TAB_CAPSULE_OVERHANG = 2.75
/** Finger travel before a press is a drag, or is left to the page's scroll. Under iOS's own 10pt, so a drag is refused its scroll in time. */
export const TAB_DRAG_SLOP = 6
/** How long the capsule takes to reach the finger when a drag starts (then it's 1:1). */
export const TAB_DRAG_CATCH_UP_MS = 120

/** What a press has become: a drag along the bar, the page's vertical scroll, or still nothing. A tie goes to the scroll. */
export function swipeIntent(dx, dy, slop = TAB_DRAG_SLOP) {
  const across = Math.abs(dx)
  const down = Math.abs(dy)
  if (Math.max(across, down) < slop) return null
  return across > down ? 'drag' : 'scroll'
}

/** The tab whose centre is closest to x; the first of two equally close. -1 with no tabs. */
export function nearestTab(centers, x) {
  let best = -1
  let distance = Infinity
  centers.forEach((center, index) => {
    const d = Math.abs(center - x)
    if (d < distance) {
      best = index
      distance = d
    }
  })
  return best
}

/** Keeps the capsule's left edge between its spots on the first and last tab. */
export function clampCapsule(x, centers, width) {
  if (!centers.length) return x
  const min = centers[0] - width / 2
  const max = centers[centers.length - 1] - width / 2
  return Math.min(max, Math.max(min, x))
}

/** A screen x in the bar's own px: the pill may be shrunk, and a finger moves in screen px. */
export function toBarX(clientX, origin, scale) {
  return scale > 0 ? (clientX - origin) / scale : clientX - origin
}

/** What's left of the gap between the capsule and the finger, `elapsed` ms into a drag: an ease out that ends at 0. */
export function catchUp(gap, elapsed, duration = TAB_DRAG_CATCH_UP_MS) {
  if (!gap || elapsed >= duration) return 0
  return gap * (1 - Math.max(0, elapsed) / duration) ** 3
}
